/**
 * Debug helper for pixel hit detection
 * This file contains utility functions to help debug hit detection issues
 */

/**
 * Create a visual representation of the hit detection scenario
 */
export const createHitDetectionVisualization = (clickPoint, shape, images) => {
  images.forEach((image, index) => {
  });

};

/**
 * Test if a point is within bounds (for debugging)
 */
export const testPointInBounds = (point, bounds) => {
  const result = {
    point,
    bounds,
    isInside:
      point.x >= bounds.left &&
      point.x <= bounds.right &&
      point.y >= bounds.top &&
      point.y <= bounds.bottom,
  };

  return result;
};

/**
 * Calculate the intersection area between a shape and an image
 */
export const calculateIntersection = (shape, image) => {
  if (shape.type === "Rect") {
    const shapeLeft = shape.x;
    const shapeRight = shape.x + shape.width;
    const shapeTop = shape.y;
    const shapeBottom = shape.y + shape.height;

    const imageLeft = image.x - image.width / 2;
    const imageRight = image.x + image.width / 2;
    const imageTop = image.y - image.height / 2;
    const imageBottom = image.y + image.height / 2;

    const intersectionLeft = Math.max(shapeLeft, imageLeft);
    const intersectionRight = Math.min(shapeRight, imageRight);
    const intersectionTop = Math.max(shapeTop, imageTop);
    const intersectionBottom = Math.min(shapeBottom, imageBottom);

    const hasIntersection =
      intersectionLeft < intersectionRight &&
      intersectionTop < intersectionBottom;

    return {
      hasIntersection,
      intersectionArea: hasIntersection
        ? {
            left: intersectionLeft,
            right: intersectionRight,
            top: intersectionTop,
            bottom: intersectionBottom,
            width: intersectionRight - intersectionLeft,
            height: intersectionBottom - intersectionTop,
          }
        : null,
    };
  }

  // For circles, this is more complex - simplified for now
  return { hasIntersection: false, intersectionArea: null };
};
